import { GalleryImageVM } from '../../shared/gallery/gallery-image-vm';

import { IMapImage } from '@ml/common';

export default class MapImageVM {
  MapImages: IMapImage[];
  AllGalleryImages: GalleryImageVM[] = [];

  constructor(data: IMapImage[], baseUrl: string) {
    if (data.length) this.MapImages = data;

    data.forEach(x => {
      if (x.ImageFilename) {
        this.AllGalleryImages.push(
          new GalleryImageVM(baseUrl, x.ImageFilename).HydrateFromMapImage(x)
        );
      } else if (x.CustomData?.GalleryItems?.length) {
        x.CustomData.GalleryItems.forEach(g => {
          const galleryImgVM = new GalleryImageVM(baseUrl, g.Filename, g.Name);
          galleryImgVM.Id = x.MapImageId;
          this.AllGalleryImages.push(galleryImgVM);
        });
      }
    });
  }
}
